import { createAsyncThunk } from '@reduxjs/toolkit'
import { getSecureSetupData } from 'src/consumer/services/secureSetupService'

export const getSetupData = createAsyncThunk(
  'setup/getData',
  async (_, { getState, fulfillWithValue, rejectWithValue, dispatch }) => {
    const { setupDataStore } = getState()
    const currentSetupData = setupDataStore?.setupData?.data

    if (currentSetupData) {
      return fulfillWithValue(currentSetupData)
    }

    try {
      const resp = await getSecureSetupData({
        preferOptimizedWebVariant: true,
      })

      if (resp?.status === 200) {
        return fulfillWithValue(resp.data)
      } else if (resp?.status === 401) {
        return rejectWithValue(resp.message)
      }

      return rejectWithValue('Unexpected response')
    } catch (error) {
      return rejectWithValue(error.message || 'Something went wrong')
    }
  },
)
